const defaultTheme = {
  primary: '#28b6ea',
  primaryAlt: '#c1e7f8',
  onPrimary: '#ffffff',
  secondary: '#646464',
  background: '#ffffff',
  success: '#79bf00',
  onSuccess: '#ffffff',
  danger: '#af022c',
  negativeTint: '#f3c4ca',
  positiveTint: '#d9ecc5',
  attentionTint: '#fee384',
  gray: '#edeff5',
};

export default defaultTheme;
